import React from 'react'
import { SelectField, SelectFieldProps } from 'scenes/Dashboard/components-next/Forms/Controllers'
import { EmailValidationStatus } from 'scenes/Dashboard/data/people/types'
import { capitalizeFirstLetter } from 'utils-next/string'

export type UserRoleSelectProps = Omit<SelectFieldProps, 'options' | 'getOptionLabel'>

const emailValidationStatusValues = Object.values(EmailValidationStatus)

function getEmailValidationStatusLabel(emailValidationStatus: EmailValidationStatus) {
  return capitalizeFirstLetter(emailValidationStatus)
}

export function EmailValidationStatusSelect(selectProps: UserRoleSelectProps) {
  return (
    <SelectField
      options={emailValidationStatusValues}
      getOptionLabel={getEmailValidationStatusLabel}
      {...selectProps}
    />
  )
}
